<template>
<p>
    <span class="heading">{{text}}</span><br/>
    <span v-html="$rc.htmlLinebreak(value)"></span>
</p>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: function() { return "" },
        },
        value: {
            type: String,
            default: function() { return "" },
        },
    },
}
</script>

<style lang="scss" scoped>
.heading {
    font-weight: bold;
}
</style>